export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9788.3f0642da.jpg";